import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'utils/apm';
import '@fontsource/metropolis';
import './index.css';
import reportWebVitals from './reportWebVitals';
// import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'utils/i18n';
import '@fortawesome/fontawesome-free/css/all.min.css';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
